import { render, staticRenderFns } from "./ReferenceDataList.vue?vue&type=template&id=41cd480e&scoped=true"
import script from "./ReferenceDataList.vue?vue&type=script&lang=ts"
export * from "./ReferenceDataList.vue?vue&type=script&lang=ts"
import style0 from "./ReferenceDataList.vue?vue&type=style&index=0&id=41cd480e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd480e",
  null
  
)

export default component.exports